var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_632",
    "data-name": "\\uADF8\\uB8F9 632",
    transform: "translate(-1333 -871)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_30",
    "data-name": "\\uD0C0\\uC6D0 30",
    cx: 17,
    cy: 17,
    r: 17,
    transform: "translate(1333 871)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pin",
    d: "M11.048,19.128l-.548.479-.548-.479C5.343,15.1,3,11.589,3,8.5A7.389,7.389,0,0,1,10.5,1,7.389,7.389,0,0,1,18,8.5C18,11.589,15.657,15.1,11.048,19.128ZM4.667,8.5c0,2.374,1.922,5.361,5.833,8.886,3.911-3.525,5.833-6.512,5.833-8.886A5.726,5.726,0,0,0,10.5,2.667,5.726,5.726,0,0,0,4.667,8.5ZM10.5,4.333A4.167,4.167,0,1,1,6.333,8.5,4.167,4.167,0,0,1,10.5,4.333ZM10.5,6A2.5,2.5,0,1,0,13,8.5,2.5,2.5,0,0,0,10.5,6Z",
    transform: "translate(1339.5 877.697)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.2286af0df293348b3253431969226518.svg";
export { ForwardRef as ReactComponent };